import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import React, {useEffect, useMemo, useState} from "react";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, CONFIG_TYPES, EDIT_FEATURE_ACTIONS} from "../../Constants";
import Button from "@amzn/meridian/button";
import {useHistory} from "react-router-dom";
import {fetchConfigs, fetchFeatures} from "../../NetworkUtils";
import {CREATE_FEATURES_BASE_ROUTE, CREATE_FEATURES_SUB_ROUTES} from "../util/RouteConstants";
import Alert from "@amzn/meridian/alert";
import Tag from "@amzn/meridian/tag";
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";

const CreateConfiguration = () => {

    const history = useHistory();

    const [action, setAction] = useState(EDIT_FEATURE_ACTIONS.ADD_CONFIGS);
    const [newConfigName, setNewConfigName] = useState();
    const [mcmId, setMcmId] = useState();
    const [configType, setConfigType] = useState();
    const [featureId, setFeatureId] = useState();
    const [featureSearchQuery, setFeatureSearchQuery] = useState();
    const [features, setFeatures] = useState([]);
    const [configs, setConfigs] = useState([]);
    const [configSearchQuery, setConfigSearchQuery] = useState();
    const [alert, setAlert] = useState({visible: false, text:"", type:""});
    const [removeConfigIds, setRemoveConfigIds] = useState([]);
    const warningAlert = {visible: true, text: "Remove Configurations request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully removed Configurations", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        fetchFeatures().then(response => setFeatures(response));
    }, []);

    useEffect(() => {
        if (action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name && featureId) {
            fetchConfigs(featureId, null).then(response => setConfigs(response.map(config => config.name)));
        }
    }, [featureId]);

    useEffect(() => {
        if (action.name !== EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name){
            clearData();
        }
    }, [action.name])

    const searchRegExpFeature = useMemo(
        () => new RegExp(featureSearchQuery, "i"),
        [featureSearchQuery]
    )

    const matchedFeature = features.filter(
        feature => !featureSearchQuery || searchRegExpFeature.test(feature)
    )

    const clearData = () => {
        setFeatureId(null);
        setRemoveConfigIds([]);
        setFeatureSearchQuery(null);
        setConfigSearchQuery(null);
    }

    const redirectByConfigType = (configType) => {
        if (CONFIG_TYPES.SDC === configType) {
            history.push({
                pathname: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.SDC_CONFIG}`,
                state: {featureId: featureId, configId: newConfigName, mcmId: mcmId}
            });
        } else if (CONFIG_TYPES.G2S2 === configType) {
            history.push({
                pathname: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.G2S2_CONFIG}`,
                state: {featureId: featureId, configId: newConfigName, mcmId: mcmId}
            });
        }
        else if(CONFIG_TYPES.AWS_APP_CONFIG === configType) {
            history.push({
                pathname: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.AWS_APP_CONFIG}`,
                state:{featureId: featureId, configId: newConfigName, mcmId:mcmId}
            });
        }
    }

    const deselectConfig = (configToBeRemoved) => {
        const configsCopy = removeConfigIds.filter(config => {return config !== configToBeRemoved;})
        setRemoveConfigIds(configsCopy);
    }

    const searchRegExpConfigs = useMemo(
        () => new RegExp(configSearchQuery, "i"),
        [configSearchQuery]
    )

    const matchedConfigs = configs.filter(
        config => !configSearchQuery || searchRegExpConfigs.test(config)
    )

    const removeConfigs = () => {
        setAlert(warningAlert);
        (async () => {
            const headers = await getHeadersForNFMS("RemoveConfigurations");
            axios
                .post(getNFMSEndpoint(), {featureId: featureId, configurationIds: removeConfigIds}, headers)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();

    }

    return (
        <div className="App">
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="small none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="createConfig.option" defaultMessage="Option"/>
                    </Text>
                    <Select
                        value={action.name}
                        width={400}
                        size={"medium"}
                        onChange={(OPTION) => setAction(EDIT_FEATURE_ACTIONS[OPTION])} >
                        {Object.entries(EDIT_FEATURE_ACTIONS).map(([key, value]) => {
                            return <SelectOption label={value.description} value={value.name} key={value.name} />
                        })}
                    </Select>
                </Column>
            </Row>

            {(action.name === EDIT_FEATURE_ACTIONS.ADD_CONFIGS.name|| action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name)?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="createConfig.feature" defaultMessage="Feature"/>
                        </Text>
                        <Select searchQuery={featureSearchQuery} onSearch={setFeatureSearchQuery}
                                value={featureId} onChange={setFeatureId} placeholder="Select Feature" width={400}>
                            {matchedFeature.map(feature => (
                                <SelectOption label={feature} value={feature} key={feature}/>
                            ))}
                        </Select>
                    </Column>
                </Row>
                : null}

            {action.name === EDIT_FEATURE_ACTIONS.CREATE_FEATURE.name ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="createConfig.newFeature" defaultMessage="New Feature Name"/>
                        </Text>
                        <Input id="feature-name" value={featureId} width={400}
                               onChange={setFeatureId} type="text" placeholder="Enter new Feature name"/>
                    </Column>
                </Row>
                : null}

            {(action.name === EDIT_FEATURE_ACTIONS.ADD_CONFIGS.name|| action.name === EDIT_FEATURE_ACTIONS.CREATE_FEATURE.name)?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="createConfig.configName" defaultMessage="New Config Name"/>
                        </Text>
                        <Input id="config-name" value={newConfigName} width={400}
                               onChange={setNewConfigName} type="text" placeholder="Enter new Config name"/>
                    </Column>
                </Row>
                : null}
            {(action.name === EDIT_FEATURE_ACTIONS.ADD_CONFIGS.name|| action.name === EDIT_FEATURE_ACTIONS.CREATE_FEATURE.name)?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="createConfig.configType" defaultMessage="Config Type"/>
                        </Text>
                        <Select value={configType} onChange={setConfigType} placeholder="Select Config Type" width={400}>
                            {Object.entries(CONFIG_TYPES).map(([key, value]) => (
                                <SelectOption label={key} value={value} key={key} />
                            ))}
                        </Select>
                    </Column>
                </Row>
                :null}
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="createConfig.mcm" defaultMessage="MCM Id"/>
                    </Text>
                    <Input id="mcm-input" value={mcmId} onChange={setMcmId} type="text" placeholder="Enter MCM Id" width={400}/>
                </Column>
            </Row>

            {(action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name)?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="removeConfig.configs" defaultMessage="Configurations"/>
                        </Text>
                        <Select searchQuery={configSearchQuery} onSearch={setConfigSearchQuery} value={removeConfigIds}
                                onChange={setRemoveConfigIds} placeholder="Select Configurations" width={400}>
                            {matchedConfigs.map(config => (
                                <SelectOption label={config} value={config} key={config} />
                            ))}
                        </Select>
                    </Column>
                </Row>
                :null}

            {(action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name)?
                <Row alignmentVertical="top" spacingInset="none none medium none" wrap="down">
                    {removeConfigIds.map(config => (
                        <Tag type="neutral" key={config} onClose={() => deselectConfig(config)}>
                            {config}
                        </Tag>
                    ))}
                </Row>
                :null}

            {(action.name === EDIT_FEATURE_ACTIONS.ADD_CONFIGS.name|| action.name === EDIT_FEATURE_ACTIONS.CREATE_FEATURE.name)?
                <Row alignmentVertical="top" spacingInset="large large large none">
                    <Button onClick={() => redirectByConfigType(configType)}>
                        <FormattedMessage id="createConfig.next" defaultMessage="Next"/>
                    </Button>
                </Row>
                :null}

            {(action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name)?
                <Row widths={["grid-3", "grid-1"]} alignmentVertical="top" spacingInset="large none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Button onClick={removeConfigs}>
                            <FormattedMessage id="removeConfig.remove" defaultMessage="Remove Configs"/>
                        </Button>
                    </Column>
                </Row>
                :null}
            {(action.name === EDIT_FEATURE_ACTIONS.REMOVE_CONFIGS.name)?
                <Row alignmentVertical="top" spacingInset="none none medium none">
                    {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
                </Row>
                :null}

        </div>
    );
}

export default injectIntl(CreateConfiguration);


// WEBPACK FOOTER //
// ./src/components/create-config/CreateConfiguration.js